Number.isNaN=Number.isNaN||function(N){return N!=N};
